/* global approvalSettingsListUrl approvalSettingsUpdateUrl */

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ApprovalSettingsList from './ApprovalSettingsList';

import { generateKey } from 'Helpers/misc';

export default function ApprovalSettings(props) {
    return (
        <>
            <ApprovalSettingsList key={generateKey()} fetchUrl={approvalSettingsListUrl} updateUrl={approvalSettingsUpdateUrl} />
        </>
    );
}

if (document.getElementById('approvalSettings')) {
    const rootEl = document.getElementById('approvalSettings'); // data attributes below help us
    ReactDOM.render(
        <App>
            <ApprovalSettings />
        </App>,
        rootEl,
    );
}
